import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-home-materials',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home-materials.component.html',
  styleUrls: ['./home-materials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeMaterialsComponent {}
